
import Vue from 'vue';
import Component from 'vue-class-component';
import Loader from '@/app/components/loaders/Loader.vue';

@Component({
  name: 'page-loader',
  components: {
    Loader
  },
  props: ['size']
})
export default class PageLoader extends Vue {}
